// extracted by mini-css-extract-plugin
module.exports = {"headerSection":"Page_headerSection__XLuXD","defaultPage":"Page_defaultPage__NFUVU","canvasLoader":"Page_canvasLoader__UaSPm","content":"Page_content__KW6Ty"};